export let panelRouter = {
  bindings: {
    data: '<',
    action: '<'
  },
  template: `
    <div class="ui-grid-cell-contents">
      <a>
        <i class="icon {{ vm.map }} i-20" style="padding-right: 5px; opacity: 1"></i>
      </a>
      <a ng-if="vm.isLinkActive(vm.action)" class="line-down" ng-click="vm.router(vm.route, vm.header)">
        {{ vm.action }}
      </a>
      <div ng-if="!vm.isLinkActive(vm.action)" class="line-down" style="display:inline-block">
        {{ vm.action }}
      </div>
    </div>`,
  controllerAs: 'vm',
  controller: ['Validations', '$state', 'CssClasses', '$cookies', 'GlobalConfig',
  function panelRouterCtrl (Validations, $state, CssClasses, $cookies, GlobalConfig) {
    const vm = this
    const currentStage = $state.current.tag

    let currentRoleId = JSON.parse($cookies.get('hasRoleId'))
    let inConsultant          = Validations.inConsultant(currentRoleId)
    let inAdminConsultantUnit = Validations.inAdminConsultantUnit(currentRoleId)

    vm.map = CssClasses.icons.map
    vm.header = {}
    vm.route = ''

    vm.router = router
    vm.isLinkActive = isLinkActive

    vm.$onInit = () => {
      vm.header = setHeader()
      vm.route = setRoute()
    }

    let inReview = Validations.inReview(currentStage)
    let inApproval = Validations.inApproval(currentStage)
    let inEvaluation = Validations.inEvaluation(currentStage)
    let inReviewExecution = Validations.inReviewExecution(currentStage)
    let isWorkplanCommittee = Validations.isWorkplanCommittee(currentRoleId) || Validations.isCommitteeRole(currentRoleId)

    function setRoute () {
      switch (true) {
        case inReview:
          return 'summaryReview'
        case inApproval:
          return 'summaryApproval'
        case inEvaluation:
          return 'summaryEvaluation'
        case inReviewExecution:
          return 'summaryReviewExecution'
        case inConsultant:
          return 'summaryConsult'
        case inAdminConsultantUnit:
          return 'summaryConsult'
        case isWorkplanCommittee:
          return 'summaryConsult'
      }
    }

    function setHeader () {
      return {
        teacherId: vm.data.teacherId,
        workplanId: vm.data.workplanId,
        name: vm.data.name
      }
    }

    function router (route, header) {
      let updatedHeader = {
        teacherId: vm.data.teacherId,
        workplanId: vm.data.workplanId,
        name: vm.data.name,
        currentStage: Object.keys(GlobalConfig.workplanIdStages).find(key => GlobalConfig.workplanIdStages[key] == vm.data.stage)
      }
      $state.go(`workplan.${route}`, updatedHeader)
    }

    function isLinkActive(action){
      if(action == 'Pendientes de ajustes')
        return false
      else
        return true
    }
  }
]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/list-panel/panel-router.js